var exports = {
  "n": "xaee3c4fa--5abfd8--rss",
};

module.exports = exports;
